import PeLink from '@pe-libs/react-components/build/components/PeLink';
import PeTooltip from '@pe-libs/react-components/build/components/PeTooltip';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import React, { FC, ReactNodeArray } from 'react';
import { InferType } from 'yup';
import useRedirect from '#hooks/useRedirect';
import { singleResultSchema } from '#modules/expertDirectory/schemas/searchDirectory';
import classNames from '#utils/classNames';
import messages from './messages';
import useStyles from './styles';

type Props = {
  data: InferType<typeof singleResultSchema>['ratings']['awards'];
};

const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent> | React.KeyboardEvent<HTMLDivElement>) =>
  event.stopPropagation();

const Awards: FC<Props> = ({ data: { topService, topRecommendation, customersChoice } }) => {
  const styles = useStyles();
  const formatMessage = useIntlMessage();
  const { urlToLivePage } = useRedirect();

  const awardsTooltip = formatMessage(messages.awardsTooltip, {
    link: (
      <PeLink href={urlToLivePage('awards')} target="_blank" className={styles.tooltipLink}>
        {formatMessage(messages.awardsTooltipLink)}
      </PeLink>
    ),
  }) as ReactNodeArray;

  return (
    <div className={styles.awardsContainer}>
      {customersChoice === true && (
        <PeTooltip title={awardsTooltip} interactive={true} leaveDelay={500}>
          <div
            role="button"
            tabIndex={0}
            className={classNames(styles.awardLabel, styles.gradientPrimary)}
            onClick={handleClick}
            onKeyPress={handleClick}
            aria-label={`${formatMessage(messages.customerChoice)} button`}
          >
            {formatMessage(messages.customerChoice)}
          </div>
        </PeTooltip>
      )}
      {topRecommendation === true && (
        <PeTooltip title={awardsTooltip} interactive={true} leaveDelay={500}>
          <div
            role="button"
            tabIndex={0}
            className={classNames(styles.awardLabel, styles.gradientSecondary)}
            onClick={handleClick}
            onKeyPress={handleClick}
            aria-label={`${formatMessage(messages.topRecommendation)} button`}
          >
            {formatMessage(messages.topRecommendation)}
          </div>
        </PeTooltip>
      )}
      {topService === true && (
        <PeTooltip title={awardsTooltip} interactive={true} leaveDelay={500}>
          <div
            role="button"
            tabIndex={0}
            onKeyPress={handleClick}
            className={classNames(styles.awardLabel, styles.gradientPrimary)}
            onClick={handleClick}
            aria-label={`${formatMessage(messages.topServiceProvider)} button`}
          >
            {formatMessage(messages.topServiceProvider)}
          </div>
        </PeTooltip>
      )}
    </div>
  );
};

export default Awards;
